<template>
  <nav app id="nav" style="width: 100%">
    <v-app-bar color="white">
      <v-row align="center">
        <img
          style="height: 3.8rem; padding-left: 20px"
          src="@/assets/one_logo_transparent.png"
        />
        <v-spacer></v-spacer>
        <h1
          class="ant-typography"
          style="
            white-space: pre-line;
            text-align: center;
            margin-left: 2%;
            font-weight: bold;
            width: 40%;
            font-size: 1rem;
          "
        >
          Sistema de reconocimiento y caracterización de Registros
          Administrativos: Republica Dominicana
        </h1>
        <v-spacer></v-spacer>
        <img style="height: 2.5rem" src="@/assets/escudo_country.png" />
      </v-row>
    </v-app-bar>

    <v-app-bar color="#002D5D">
      <v-btn
        depressed
        @click="goTo(''), (selectedItem = null)"
        style="color: white"
        color="#002D5D"
      >
        inicio
      </v-btn>
      <v-spacer></v-spacer>
      <v-menu left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn rounded v-bind="attrs" v-on="on">
            {{ username }}
            <v-icon>mdi-account</v-icon>
          </v-btn>
          <v-badge bordered overlap left v-show="notificationsPending()">
            <v-btn icon>
              <v-icon>mdi-bell</v-icon>
            </v-btn>
          </v-badge>
          <v-btn plain style="color: white" @click="goTo('guias')">
            Ayudas y guías
          </v-btn>
          <v-btn plain style="color: white" @click="goTo('inventario')">
            inventario
          </v-btn>
        </template>
        <v-list style="min-height: 100%">
          <v-list-item
            v-for="(item, i) in logItems"
            :key="i"
            @click="goTo(item.title)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer
      v-if="logged"
      v-model="drawer"
      permanent
      app
      style="min-height: 100%"
      color="#002D5D"
    >
      <v-btn
        style="margin-top: 2rem; padding-left: 12.5%"
        plain
        v-ripple="false"
      >
        <img
          @click="goTo('')"
          style="height: 5rem"
          src="@/assets/one_logo_inverted_transparent.png"
        />
      </v-btn>
      <v-divider dark style="margin-top: 2rem"></v-divider>

      <v-list style="margin-top: 1.5rem">
        <v-list-item-group v-model="selectedItem" dark color="primary">
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            @click="goTo(item.value)"
          >
            <v-icon dark>{{ item.icon }}</v-icon>
            <v-list-item-content style="margin-left: 5%; color: white">{{
              item.title
            }}</v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import {
  getCookie,
  setCookie,
  getCurrentUser,
  setWithExpiry,
  getWithExpiry,
} from "@/utils/apiRequest.js";
export default {
  data: () => ({
    drawer: true,
    group: null,
    selectedItem: null,
    items: [
      {
        title: "Identificación R.A",
        value: "identificacion",
        icon: "mdi-file-document-edit",
      },
      {
        title: "Visualizar registros",
        value: "registros",
        icon: "mdi-text-box-search",
      },
      { title: "Administrar usuarios", value: "usuarios", icon: "mdi-account" },
      {
        title: "Administrar organizaciones",
        value: "organizaciones",
        icon: "mdi-account-group",
      },
      {
        title: "Administrar auxiliares",
        value: "auxiliares",
        icon: "mdi-comment-question",
      },
      { title: "Administrar roles", value: "roles", icon: "mdi-account-lock" },
      {
        title: "Administrar permisos",
        value: "permisos",
        icon: "mdi-shield-account",
      },
      { title: "Cortes", value: "cortes", icon: "mdi-book-check" },
      {
        title: "Administrar guías",
        value: "guias/administrar",
        icon: "mdi-text-box",
      },
      {
        title: "Visualizar gráficos",
        value: "graficos",
        icon: "mdi-chart-arc",
      },
      {
        title: "Ver reportes",
        value: "reportes",
        icon: "mdi-file-chart",
      },
    ],
    generalItems: [
      { title: "Inicio", value: "" },
      { title: "Identificación R.A", value: "identificacion" },
      { title: "Visualizar registros", value: "registros" },
    ],
    logItems: [{ title: "login" }],
    username: null,
    logged: false,
    counts: null,
  }),
  methods: {
    goTo(where) {
      if (where == "logout") {
        setCookie("jwt", "", 100); //delete token after 100 miliseconds
        setWithExpiry("user", "", 100);
        localStorage.removeItem("user");
        localStorage.removeItem("jwt");
        this.$router.push("/#out");
        location.reload();
      } else {
        try {
          const path = `/${where}`;
          if (this.$route.path !== path) this.$router.push(path);
        } catch (error) {
          console.log(error);
        }
      }
    },
    notificationsPending() {
      if (this.counts > 0) {
        return true;
      }
      return false;
    },
  },

  async mounted() {
    var cookie = getCookie("jwt");
    if (!cookie) {
      this.logItems = [{ title: "login" }];
    } else {
      let user = JSON.parse(getWithExpiry("user"));
      if (user != null) {
        this.username = user.userName;
        this.logItems = [{ title: "logout" }];
        this.logged = true;
        let response = await getCurrentUser();
        if (response.data) {
          if (response.data.status == "success") {
            this.counts = response.data.notification;
          }
        }
      }
    }
  },
};
</script>